import { useQuery } from "@tanstack/react-query";

import { budgetVsActualService } from "~/services/contabilidad/budgetVsActualService";

import type { BudgetVsActualFilters } from "~/types/contabilidad";

export const BUDGET_VS_ACTUAL_QUERY_KEY = ["budget-vs-actual"];

export function useBudgetVsActual(filters: BudgetVsActualFilters) {
  return useQuery({
    queryKey: [...BUDGET_VS_ACTUAL_QUERY_KEY, filters],
    queryFn: () => budgetVsActualService.getBudgetVsActual(filters),
    // Not gated on budgetId: with no budget selected the RPC still returns the
    // real side with budget columns at 0 (matches the "Sin presupuesto" note).
    enabled:
      !!filters.year &&
      !!filters.month &&
      !!filters.companyId &&
      !!filters.templateId,
  });
}
